import {
  PageContainer,
  PageContent,
  PageFooterBar,
} from "../../components/PageContainer";
import _ from "lodash";
import { BreadCrumbs, TitleBar } from "../../components/TitleBar";
import { BackButton, SaveButton } from "../../components/Button";
import { useEffect, useState } from "react";
import apiAgent from "../../api/apiAgent";
import { useNavigate, useParams } from "react-router";
import { useAtomValue } from "jotai";
import { modelDataAtom, useValidateModel } from "../../atoms";
import { getDataAndSchemaFromModel } from "../../components/Forms/utils";
import { tMsg } from "../../components/ToastNotifications";
import { checkTitle, useOriginParams } from "../../utils";
import { useSearchParams } from "react-router-dom";
import UsersForm from "./form";

const CreateUser = (): JSX.Element => {
  const [originFrom, originId] = useOriginParams();
  const modelData = useAtomValue(modelDataAtom);
  const modelName = "users";
  // useValidateModel(modelName);

  const capitalizedName = checkTitle(modelName);

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [itemData, setItemData] = useState<any>(null);
  const [schema, setSchema] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    if (modelData && modelData !== null && isLoading) {
      const [emptyData, getSchema] = getDataAndSchemaFromModel(
        modelData,
        modelName,
        true
      );

      getSchema.push({ name: "confirmPassword", type: "string" });

      // Check to use searchParams to autofill fields
      const dataWithParams = getSchema.reduce((obj, item) => {
        const key = item.name;
        const checkValue = searchParams.get(key);
        if (searchParams.get(key))
          return {
            ...obj,
            [key]: checkValue,
          };
        return obj;
      }, {});

      // Check origin values to use for returning when creating from parent IDs
      const originValues =
        originFrom && originId
          ? {
              [`owner_${originFrom}_id`]: parseInt(originId || "-1"),
            }
          : {};

      setItemData({
        ...emptyData,
        ...dataWithParams,
        ...originValues,
        confirmPassword: "",
      });
      setSchema(getSchema);
      setIsLoading(false);
    }
  }, [modelData]);

  const saveItem = async () => {
    if (
      itemData.password &&
      itemData.password.length > 0 &&
      itemData.password !== itemData.confirmPassword
    ) {
      tMsg.error("Passwords do not match");
      return;
    }

    try {
      // TODO: Add this back if you need (admin) users creating users
      const response = await apiAgent.Users.create(modelName, {
        ...itemData,
        mfa_verified: false,
      });
      if (response.status === 200) {
        tMsg.success(`${capitalizedName} successfully created`);
        if (originFrom && originId)
          navigate(`/m/${originFrom}/show/${originId}`);
        else if (response?.data?.newId)
          navigate(`/m/${modelName}/show/${response.data.newId}`);
        else navigate(`/m/${modelName}`);
      } else throw response.statusText;
    } catch (err: any) {
      if (err.response?.status === 401)
        tMsg.info(
          "You may only view/modify users within 15 minutes of logging in"
        );
      else tMsg.error(`${_.capitalize(err.response?.data)}`);
      console.log(err);
    }
  };

  const crumbs = [
    {
      label: checkTitle(modelName),
      link: `/m/${modelName}`,
    },
  ];

  return (
    <PageContainer isLoading={isLoading} className="relative">
      <PageContent reduceHeightForFooter>
        <BreadCrumbs crumbs={crumbs} />
        <TitleBar title={`Create ${capitalizedName}`}>
          <BackButton />
        </TitleBar>
        <UsersForm
          modelName={modelName}
          itemData={itemData}
          setItemData={setItemData}
          schema={schema}
          onSubmit={(e) => {
            // e.preventDefault();
            saveItem();
          }}
        />
      </PageContent>
      <PageFooterBar>
        <SaveButton onClick={() => saveItem()} />
      </PageFooterBar>
    </PageContainer>
  );
};

export default CreateUser;
